/** @jsx jsx */
import { React } from 'react';
import { jsx } from '@emotion/core';
import compose from 'lodash/fp/compose';
import get from 'lodash/get';
import defaultsDeep from 'lodash/defaultsDeep';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import he from 'he';
import DotComponent from '../../ui/DotComponent';
import { Container, Row, Column, MediaQueries } from '../../../styles/Grid';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import * as styles from './index.styles';
import Spacer from '../../ui/Spacer';
import { Breakpoints } from '../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';
import Picture from '../../ui/Picture';
import { hideElementCss, showElementCss } from '../../../utils/responsive';

const mainImageSizes = {};

const defaultData = {};
export class CompanyLogos extends SafePureComponent {
  constructor(props) {
    super(props);
    this.state = { windowWidth: 0 };
    this.fields = defaultsDeep(props.rendering.fields, defaultData);
  }

  safeRender() {
    let LogoImages = get(this.fields, 'LogoImages', []);
    let columnClass = 'grid-' + LogoImages.length;

    return (
      <Spacer customCss={styles.containerSizesTop}>
        <Container css={[styles.brandlogo]}>
          <h2>
            {he.decode(this.fields.Heading.value)}
            <DotComponent />
          </h2>

          <Row css={[styles.card_component_top]} className={columnClass}>
            {LogoImages.map(function (item, index) {
              const imageSrc = {
                value: {
                  src: item,
                  alt: 'company logo ' + index,
                },
              };

              return (
                <Column
                  css={[styles.cardscomponent]}
                  cols={{ xs: 3, sm: 3, md: 2, lg: 2 }}
                  key={index}
                >
                  <div className="card_sec">
                    {/* <img src={item} alt={item} /> */}
                    <Picture image={imageSrc} imageSizes={mainImageSizes} />
                  </div>
                </Column>
              );
            })}
          </Row>

          {/* <div className="hr_sec">
          <hr />
        </div> */}
        </Container>
      </Spacer>
    );
  }
}

CompanyLogos.displayName = 'CompanyLogos';

export default compose(withNamespaces(), withSitecoreContext())(CompanyLogos);
